import { loading, success, handleErrorException, reset } from 'State/actions';
import * as types from './types';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';

const resourceName = 'iprange';
const humanName = 'IP Range';

export const getIPs = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NETWORKFILTERING_GETIPS_LOADING, true));

      const response = await MPWWebApi.getGeneric(resourceName);
      dispatch(
        success(types.NETWORKFILTERING_GETIPS_SUCCESS, response.data.Data)
      );
    } catch (err) {
      dispatch(
        handleErrorException(err, types.NETWORKFILTERING_GETIPS_ERROR, {
          title: 'Error',
          Message: `Unable to get ${humanName}s.`,
        })
      );
    } finally {
      dispatch(loading(types.NETWORKFILTERING_GETIPS_LOADING, false));
    }
  };
};

export const getEnabled = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NETWORKFILTERING_GETENABLED_LOADING, true));

      const response = await MPWWebApi.getGeneric(`${resourceName}/enabled`);

      dispatch(
        success(types.NETWORKFILTERING_GETENABLED_SUCCESS, response.data.Data)
      );
    } catch (err) {
      dispatch(
        handleErrorException(err, types.NETWORKFILTERING_GETENABLED_ERROR, {
          Title: 'Error',
          Message: 'Unable to get network filtering preference.',
        })
      );
    } finally {
      dispatch(loading(types.NETWORKFILTERING_GETENABLED_LOADING, false));
    }
  };
};

export const setEnabled = value => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NETWORKFILTERING_SETENABLED_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `${resourceName}/enabled`,
        value
      );

      await dispatch(getEnabled());

      dispatch(
        success(types.NETWORKFILTERING_SETENABLED_SUCCESS, response.data.Data)
      );
    } catch (err) {
      dispatch(
        handleErrorException(err, types.NETWORKFILTERING_SETENABLED_ERROR, {
          Title: 'Error',
          Message: 'Unable to set network filtering preference.',
        })
      );
    } finally {
      dispatch(loading(types.NETWORKFILTERING_SETENABLED_LOADING, false));
    }
  };
};

export const clearSetEnabledResult = () => {
  return dispatch => {
    dispatch(reset(types.NETWORKFILTERING_SETENABLED_SUCCESS, null));
    dispatch(reset(types.NETWORKFILTERING_SETENABLED_ERROR, null));
  };
};

export const postIP = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NETWORKFILTERING_POSTIP_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        resourceName,
        data
      );

      await dispatch(getIPs());

      dispatch(
        success(types.NETWORKFILTERING_POSTIP_SUCCESS, response.data.Data)
      );
    } catch (err) {
      dispatch(
        handleErrorException(err, types.NETWORKFILTERING_POSTIP_ERROR, {
          title: 'Error',
          Message: `Unable to add or update ${humanName}.`,
        })
      );
    } finally {
      dispatch(loading(types.NETWORKFILTERING_POSTIP_LOADING, false));
    }
  };
};

export const clearPostIPResult = () => {
  return dispatch => {
    dispatch(reset(types.NETWORKFILTERING_POSTIP_SUCCESS, null));
    dispatch(reset(types.NETWORKFILTERING_POSTIP_ERROR, null));
  };
};

export const getMyIP = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NETWORKFILTERING_GETMYIP_LOADING, true));

      const response = await MPWWebApi.getGeneric(`${resourceName}/myip`);
      dispatch(
        success(types.NETWORKFILTERING_GETMYIP_SUCCESS, response.data.Data)
      );
    } catch (err) {
      dispatch(
        handleErrorException(err, types.NETWORKFILTERING_GETMYIP_ERROR, {
          Title: 'Error',
          Message: 'Could not get current IP.',
        })
      );
    } finally {
      dispatch(loading(types.NETWORKFILTERING_GETMYIP_LOADING, false));
    }
  };
};

export const clearGetMyIPResult = () => {
  return dispatch => {
    dispatch(reset(types.NETWORKFILTERING_GETMYIP_SUCCESS, null));
    dispatch(reset(types.NETWORKFILTERING_GETMYIP_ERROR, null));
  };
};

export const postDeleteIP = id => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NETWORKFILTERING_POSTDELETEIP_LOADING, true));

      const response = await MPWWebApi.postGenericDelete(resourceName, id);

      await dispatch(getIPs());

      dispatch(
        success(types.NETWORKFILTERING_POSTDELETEIP_SUCCESS, response.data.Data)
      );
    } catch (err) {
      dispatch(
        handleErrorException(err, types.NETWORKFILTERING_POSTDELETEIP_ERROR, {
          title: 'Error',
          Message: `Unable to delete ${humanName}.`,
        })
      );
    } finally {
      dispatch(loading(types.NETWORKFILTERING_POSTDELETEIP_LOADING, false));
    }
  };
};

export const clearPostDeleteIPResult = () => {
  return dispatch => {
    dispatch(reset(types.NETWORKFILTERING_POSTDELETEIP_SUCCESS, null));
    dispatch(reset(types.NETWORKFILTERING_POSTDELETEIP_ERROR, null));
  };
};

export const getValidateMyIP = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.NETWORKFILTERING_GETMYIPVALID_LOADING, true));

      const response = await MPWWebApi.getGeneric(
        `${resourceName}/validatemyip`
      );

      if (response.data.Data !== true) {
        dispatch(
          setNotificationDialog(
            NOTIFICATION_DIALOG_MESSAGES.NETWORKFILTERING_IPNOTVALID
          )
        );
      }

      dispatch(
        success(types.NETWORKFILTERING_GETMYIPVALID_SUCCESS, response.data.Data)
      );
    } catch (err) {
      dispatch(
        handleErrorException(err, types.NETWORKFILTERING_GETMYIPVALID_ERROR, {
          Title: 'Error',
          Message: 'Could not validate current IP.',
        })
      );
    } finally {
      dispatch(loading(types.NETWORKFILTERING_GETMYIPVALID_LOADING, false));
    }
  };
};

export const clearGetValidateMyIPResult = () => {
  return dispatch => {
    dispatch(reset(types.NETWORKFILTERING_GETMYIPVALID_SUCCESS, null));
    dispatch(reset(types.NETWORKFILTERING_GETMYIPVALID_ERROR, null));
  };
};



// WEBPACK FOOTER //
// ./src/pages/networkfiltering/state/actions.js